import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Signing } from '../models/signing.model';

interface ClearSignRedirectUrlResponse {
  url: string;
}

@Injectable({ providedIn: 'root' })
export class SigningService {
  private readonly http = inject(HttpClient);

  getByParticipantId(participantId: string): Observable<Signing> {
    const url = `/api/v1/participants/${participantId}/signing`;
    return this.http.get<Signing>(url);
  }

  getClearSignRedirectUrl(signingId: string): Observable<ClearSignRedirectUrlResponse> {
    return this.http.get<ClearSignRedirectUrlResponse>(
      `/api/v1/signings/${signingId}/clearsign-url`,
    );
  }

  getClearSignHandoffUrl(participantId: string): Observable<ClearSignRedirectUrlResponse> {
    return this.http.get<ClearSignRedirectUrlResponse>(
      `/api/v1/participants/${participantId}/notary-session-handoff-url`,
    );
  }
}
